import { useEffect } from 'react';

/**
 * Hook to preload common routes to improve navigation performance
 * Should be called in the main App component after initial load
 */
export const useRoutePreloader = () => {  useEffect(() => {
    // Only preload after a short delay to avoid interfering with initial load
    const timer = setTimeout(() => {
      // Preload commonly navigated routes (only lazy-loaded ones)
      // Settings and FAQ are now direct imports, so don't preload them
      import('../pages/LiveTrades').catch(() => {});
      import('../pages/ClosedTradesPage').catch(() => {});
      import('../pages/StrategyDetailsPage').catch(() => {});
      import('../pages/PortfolioCommandCenterPage').catch(() => {});
    }, 2000); // Wait 2 seconds after initial load

    return () => clearTimeout(timer);
  }, []);
};

export default useRoutePreloader;
